module.exports = __webpack_public_path__ + "img/full3-min.2f98d8e0.png";